import { Button } from '@/components/ui/button'

interface HeroProps {
  handleClick: () => void
}
export default function Hero({ handleClick }: HeroProps) {
  return (
    <>
      <div className="h-[500px] bg-[url('/img/landing/bg-hero-mobile.jpg')] bg-cover bg-center bg-no-repeat pt-14 md:bg-[url('/img/landing/bg-hero.jpg')]">
        <div className="flex h-full w-full flex-col items-center justify-center">
          <div className="hidden text-center text-5xl font-semibold leading-[4rem] md:block md:justify-center">
            Wujudkan Karir Impian <br />
            Bersama <span className="text-primary-yes">YES.co.id</span>
          </div>
          <div className="text-center text-2xl font-semibold leading-[2rem] md:hidden">
            Wujudkan Karir <br />
            Impian <br /> Bersama{' '}
            <span className="text-primary-yes">YES.co.id</span>
          </div>
          <div className="mt-4 px-8 text-center text-sm font-light tracking-wider md:px-0 md:text-lg">
            Platform untuk pencari kerja dan persiapan kerja di jepang
          </div>
          <div className="mt-8 flex items-center gap-4 px-8 md:px-0">
            <img src="/img/landing/profile-group.svg" />
            <div className="md:text-md text-sm font-semibold tracking-wide">
              Temukan peluang karir di Jepang bersama pengguna lainnya
            </div>
          </div>
          <div className="mt-6">
            {' '}
            <Button
              className="bg-primary-yes hover:bg-primary-yes"
              onClick={handleClick}
            >
              Cari Lowongan
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
